import { Injectable, TemplateRef, ViewChild } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { of, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class MessageService {
  constructor(private readonly message: NzMessageService) {}

  public success(content: string, duration: number = 2000) {
    this.message.create('success', content, {
      nzDuration: duration,
      nzAnimate: true,
      nzPauseOnHover: true,
    });
  }
  public error(content: string, duration: number = 2000) {
    this.message.create('error', content, {
      nzDuration: duration,
      nzAnimate: true,
      nzPauseOnHover: true,
    });
  }
  public info(content: string, duration: number = 2000) {
    this.message.create('info', content, {
      nzDuration: 0,
      nzAnimate: true,
      nzPauseOnHover: true,
    });
  }
  public warning(content: string, duration: number = 2000) {
    this.message.create('warning', content, {
      nzDuration: duration,
      nzAnimate: true,
      nzPauseOnHover: true,
    });
  }
  public loading(content: string = 'loaing...'): Observable<string> {
    const id = this.message.loading(content, { nzDuration: 0 }).messageId;
    return of(id);
  }
  public remove(messageId: string | undefined) {
    this.message.remove(messageId);
  }
  public myInfo(content: string) {
    const infoRef = `<div class="amelo-alert amelo-alert-important amelo-alert-info amelo-alert-dismissible" role="alert">
      <div class="d-flex">
        <div>
          <!-- Download SVG icon from http://tabler-icons.io/i/info-circle -->
          <!-- SVG icon code with class="alert-icon" -->
        </div>
        <div>
          ${content}
        </div>
      </div>
      <a class="btn-close btn-close-white" data-bs-dismiss="alert" aria-label="close"></a>
    </div>`;
    this.message.create('myInfo', infoRef, {
      nzDuration: 0,
      nzAnimate: true,
      nzPauseOnHover: true,
    });
  }
}
